import { render } from "./UserFaceRecognition.vue?vue&type=template&id=4bbb69ac&scoped=true"
import script from "./UserFaceRecognition.vue?vue&type=script&lang=js"
export * from "./UserFaceRecognition.vue?vue&type=script&lang=js"

import "./UserFaceRecognition.vue?vue&type=style&index=0&id=4bbb69ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbb69ac"]])

export default __exports__